import { BrowserRouter } from "react-router-dom"
import { Container } from "./styles"
import ScrollAnimation from "react-animate-on-scroll"
import Illustration from "../../assets/illustration.svg"
import { NavHashLink } from "react-router-hash-link"
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
import Hello from '../../assets/Hello.gif'
import telegram from '../../assets/telegram.svg'
import { CV_FILE_NAME, CV_URL } from "../../constants"
import { useLanguage } from "../../i18n/LanguageContext"

export function Hero() {
  const { t } = useLanguage()
  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
          <p className="eyebrow">{t.hero.eyebrowBefore} <img src={Hello} alt="" width="20" />{t.hero.eyebrowAfter}</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>{t.hero.headline}</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
          <p className="lede">
            {t.hero.ledeBefore} <strong>{t.hero.ledeStrong}</strong>{t.hero.ledeAfter}
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <div className="hero-actions">
            <BrowserRouter>
              <NavHashLink smooth to="#contact" className="button">{t.hero.contact}</NavHashLink>
              <NavHashLink smooth to="#case-ok-delivery" className="button button-ghost">
                {t.hero.readCase} <span aria-hidden="true">→</span>
              </NavHashLink>
            </BrowserRouter>
            <a className="cv-link" href={CV_URL} download={CV_FILE_NAME}>
              {t.hero.downloadCv} <span aria-hidden="true">↓</span>
            </a>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <div className="social-media">
            <a
              href="https://www.linkedin.com/in/hdariodev"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="Linkedin" />
            </a>
            <a
              href="https://github.com/hdariodev/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={githubIcon} alt="GitHub" />
            </a>
            <a
              href="https://wa.me/59178872560?text=Hello%20Dar%C3%ADo"
              target="_blank"
              rel="noreferrer"
            >
              <img src={whatsapp} alt="Whatsapp" />
            </a>
            <a
              href="https://t.me/hdariodev"
              target="_blank"
              rel="noreferrer"
            >
              <img src={telegram} alt="telegram" />
            </a>
          </div>
        </ScrollAnimation>

      </div>


      <div className="hero-image">
        <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
          <img src={Illustration} alt="" aria-hidden="true" />
        </ScrollAnimation>
      </div>

    </Container>

  )
}
